'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var plugin = require('tailwindcss/plugin');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var plugin__default = /*#__PURE__*/_interopDefaultCompat(plugin);

var typographyCode = plugin__default.default(({ addUtilities, theme })=>{
    // NOTE: Euclid Typography Code components require Code font to be enabled.
    if (!theme('fontFamily.code')) {
        return;
    }
    const typographyCodeTypes = {
        // CODE - BASE
        code: {
            base: {
                fontWeight: theme('fontWeight.code.regular'),
                fontSize: theme('fontSize.base'),
                lineHeight: theme('lineHeight.7')
            },
            'base-bold': {
                fontWeight: theme('fontWeight.code.bold'),
                fontSize: theme('fontSize.base'),
                lineHeight: theme('lineHeight.7')
            }
        }
    };
    /**
     * Nested reduce: loops through object and creates `type` utility classes.
     * @example
     * ```
     * {
     *    .type-code-base: {
     *      fontFamily: "ui-monospace, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace";
     *      fontWeight: 400;
     *      fontSize: "1rem";
     *      lineHeight: "1.75rem";
     *    },
     *    .type-code-base-bold: {
     *      fontFamily: "ui-monospace, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace";
     *      fontWeight: 700;
     *      fontSize: "1rem";
     *      lineHeight: "1.75rem";
     *    }
     * }
     * ```
     */ const typographyCodeUtilityClasses = Object.entries(typographyCodeTypes).reduce((typesAcc, [typeName, variants])=>{
        const classes = Object.entries(variants).reduce((variantAcc, [variantName, styles])=>{
            return {
                ...variantAcc,
                [`.type-${typeName}-${variantName}`]: {
                    fontFamily: theme(`fontFamily.code`),
                    ...styles
                }
            };
        }, {});
        return {
            ...typesAcc,
            ...classes
        };
    }, {});
    addUtilities(typographyCodeUtilityClasses);
});

exports.default = typographyCode;
//# sourceMappingURL=typography-code.js.map
